import Presentation from "./presentation";

const MobileVideoCard = ( { data } ) => {
	return (
		<Presentation data = { data } />
	);
};

export default MobileVideoCard;